import DayPickerInput from 'react-day-picker/DayPickerInput';
import React, { useEffect, useState } from 'react';
import XLSX from 'xlsx';
import axios from 'axios';
import moment from 'moment';
import { Form, Formik } from 'formik';
import { Link } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { formatDate, parseDate } from 'react-day-picker/moment';
import { isEmpty } from 'lodash';
import { search } from '../../../actions/report';
import { Label } from '../../../components';
import { SET_MESSAGE } from '../../../actions/utils';
import CryptoJS from "crypto-js";

// TODO paging
const LeadList = ({ data }) => {
  const [items, setItems] = useState([]);
  const [itemPerPage, setItemPerPage] = useState(20);
  const [row, setRow] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  // TODO decrypt AES
  const decryptAES  = (cipherText) => {
    if(cipherText === null) return '';
    cipherText = cipherText.replace('[encrypt]','');
    const decrypted = CryptoJS.AES.decrypt(cipherText, CryptoJS.enc.Utf8.parse('A9F66A37C4C10BBD83F7BA270962731E'), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    return CryptoJS.enc.Utf8.stringify(decrypted);
  }
  useEffect(() => {
    setItems(data || []);
    let row = (data || []).slice(0, itemPerPage);
    setRow(row);
    setCurrentPage(1);
    setTotalPages(Math.floor((data || []).length / itemPerPage) + 1);
  }, [data, itemPerPage]);

  const renderBack = () => {
    return currentPage <= 1 ? null : (
      <a
        className='text-primary'
        onClick={() => {
          const prevPage = currentPage - 1;
          if (prevPage > 0) {
            const row = items?.slice(prevPage * itemPerPage, currentPage * itemPerPage);
            setRow(row);
            setCurrentPage(prevPage);
          }
        }}
      >
        {'<< '}Trước
      </a>
    );
  };

  const renderNext = () => {
    return currentPage >= totalPages ? null : (
      <a
        className='text-primary'
        onClick={() => {
          const nextPage = currentPage + 1;
          if (nextPage <= totalPages) {
            const row = items?.slice(currentPage * itemPerPage, nextPage * itemPerPage);
            setRow(row);
            setCurrentPage(nextPage);
          }
        }}
      >
        Sau {' >>'}
      </a>
    );
  };

  const renderPageIndex = () => {
    if (totalPages <= 1) return null;
    return (
      <span>
        Trang {currentPage} / {totalPages}
      </span>
    );
  };

  const renderItemPerPage = () => {
    return (
      <div className='input-group'>
        <label className='input-group-text bg-white border-0 font-weight-bold'>Số hàng mỗi trang</label>
        <select value={itemPerPage} onChange={(e) => setItemPerPage(e.target.value)} className='form-control'>
          <option>5</option>
          <option>10</option>
          <option>20</option>
          <option>50</option>
          <option>100</option>
        </select>
      </div>
    );
  };

  const renderPaging = () => {
    return (
      <div className='d-flex justify-content-between align-items-center'>
        <div>{renderBack()}</div>
        <div>{renderItemPerPage()}</div>
        <div>{renderPageIndex()}</div>
        <div>{renderNext()}</div>
      </div>
    );
  };

  return (
    <table className='table'>
      <thead className='bg-secondary text-white'>
        <tr>
          <th className='align-top'>Mã tham chiếu</th>
          <th className='align-top'>Người giới thiệu</th>
          <th className='align-top'>Ngày giới thiệu</th>
          <th className='align-top'>Thời gian cập nhật gần nhất</th>
          <th className='align-top'>Tên KH</th>
          <th className='align-top'>Ngày sinh</th>
          <th className='align-top'>Số điện thoại</th>
          <th className='align-top'>Email</th>
          <th className='align-top'>Tình trạng</th>
        </tr>
      </thead>
      <tbody>
        {row?.map((lead, i) => (
          <tr key={`${lead?.seq || ''}_${i}`}>
            <td>{lead?.ref_no}</td>
            <td>{lead?.bank_staff_name}</td>
            <td>{lead?.created_date}</td>
            <td>{lead?.last_modified_date}</td>
            <td>
              <Link to={`/leads/${lead.seq}`}>{decryptAES(lead?.customer_name)}</Link>
            </td>
            <td>{decryptAES(lead?.dob)}</td>
            <td>{decryptAES(lead?.mobile_number)}</td>
            <td>{decryptAES(lead?.email)}</td>
            <td>{lead?.status}</td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={9}>{renderPaging()}</td>
        </tr>
      </tfoot>
    </table>
  );
};

const HOInternal = ({
  initialValues = {
    from: null,
    to: null,
  },
  data = null,
  onSubmit,
}) => {
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();

  if (!initialValues.from)
    initialValues = {
      ...initialValues,
      from: moment().subtract(1, 'month').toDate(),
    };

  const handleClick = async () => {
    try {
      setLoading(true);
      let data = { name: 'DOB' };
      if (initialValues.from != null)
        data = {
          ...data,
          from: moment(initialValues.from).format('DD/MM/YYYY'),
        };
      if (initialValues.to != null)
        data = {
          ...data,
          to: moment(initialValues.to).format('DD/MM/YYYY'),
        };

      let res = await axios.post('/api/dob?report', data);
      let { content, header, title, size } = res.data || {};

      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: 'Báo cáo',
        Subject: 'Báo cáo',
        Author: 'FWD',
        CreatedDate: new Date(),
      };

      let opts = isEmpty(header) ? {} : { header };
      let ws = XLSX.utils.json_to_sheet(content, opts);
      let i = 'A'.charCodeAt(0);
      let prefix = '';
      (title || []).map((t) => {
        let col = prefix + String.fromCharCode(i);
        let cell = col + '1';
        ws[cell].v = t;
        ws[cell].s = { font: { bold: true } };
        i = i + 1;
        if (i > 'Z'.charCodeAt(0)) {
          i = 'A'.charCodeAt(0);
          prefix = prefix ? String.fromCharCode(prefix.charCodeAt(0) + 1) : 'A';
        }
      });

      if (size?.length > 0) ws['!cols'] = (size || []).map((e) => ({ wch: e }));

      wb.SheetNames.push('Data');
      wb.Sheets['Data'] = ws;
      let fileName = 'Report_' + moment().format('YYYYMMDD_hhmmss') + '.xlsx';
      XLSX.writeFile(wb, fileName);
      setLoading(false);
    } catch (error) {
      console.log(error);
      dispatch({ type: SET_MESSAGE, payload: ' ' });
      setLoading(false);
    }
  };

  return (
    <div className='ho-internal'>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {(props) => {
          console.log('props -> ', props);
          return (
            <>
              <Form className='mb-3'>
                <div className='row col-md-12 d-flex flex-md-row flex-sm-column'>
                  <div className='form-group mr-3'>
                    <Label>Từ ngày</Label>
                    <div>
                      <DayPickerInput
                        format='DD/MM/YYYY'
                        formatDate={formatDate}
                        parseDate={parseDate}
                        placeholder='DD/MM/YYYY'
                        onDayChange={(date) => props.setFieldValue('from', date)}
                        value={props.values?.from}
                        inputProps={{ className: 'form-control' }}
                      />
                    </div>
                  </div>
                  <div className='form-group mr-3'>
                    <Label>Đến ngày</Label>
                    <div>
                      <DayPickerInput
                        format='DD/MM/YYYY'
                        formatDate={formatDate}
                        parseDate={parseDate}
                        placeholder='DD/MM/YYYY'
                        onDayChange={(date) => props.setFieldValue('to', date)}
                        value={props.values?.to}
                        inputProps={{ className: 'form-control' }}
                      />
                    </div>
                  </div>
                </div>
                <button type='submit' className='btn btn-primary text-uppercase px-4' disabled={props.isSubmitting}>
                  Tìm kiếm
                </button>
              </Form>
            </>
          );
        }}
      </Formik>
      <div>
        {data && (
          <span>
            Tìm thấy <b>{data.length}</b> kết quả
          </span>
        )}
        {data?.length > 0 ? (
          <button
            type='button'
            className='btn btn-outline-primary text-uppercase float-right'
            disabled={loading}
            onClick={handleClick}
          >
            Tải báo cáo
          </button>
        ) : null}
      </div>

      {data && data?.length > 0 ? <LeadList data={data} /> : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  const initialValues = state?.report?.condition;
  const data = state?.report?.data;

  return { initialValues, data };
};

const mapDispatchToProps = { onSubmit: search };

export default connect(mapStateToProps, mapDispatchToProps)(HOInternal);
